routes.$inject = ['$stateProvider'];

export default function routes($stateProvider) {
  $stateProvider
    .state('editMatch', {
      url: '/edit/ideal-match',
      template: require('./index.html'),
      controller: 'EditMatchController',
      controllerAs: 'editMatch',
      authRequired: true,
      resolve: {
        secure: (panel) => {
          // todo: implement method
        }
      },
      onEnter: function (secure) {
        // todo: implement method
      }
    });
}



// WEBPACK FOOTER //
// ./src/app/features/edit-match/routes.js